/*
 * Farida Gupta - product size chart modal (theme/snippets/size-chart-modal.liquid).
 *
 * The metaobject only stores one unit (inches) - there's no separate cm dataset - so the CM/IN
 * toggle converts the stored inch value to cm on the fly instead of swapping between two
 * server-rendered datasets. Values are ranges like "31-32" or single numbers like "34"; every
 * numeric token in the string is converted independently so the "-" separator survives.
 */
function inchesToCm(value) {
  return value.replace(/\d+(\.\d+)?/g, (match) => {
    const cm = Math.round(parseFloat(match) * 2.54 * 10) / 10;
    return String(cm);
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-size-chart-unit-toggle]');
  if (!toggle) return;

  const modalBody = toggle.closest('.size-chart-modal__body');
  if (!modalBody) return;

  const unit = toggle.getAttribute('data-size-chart-unit-toggle');
  if (modalBody.getAttribute('data-size-chart-unit') === unit) return;

  modalBody.setAttribute('data-size-chart-unit', unit);

  modalBody.querySelectorAll('[data-size-chart-unit-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.getAttribute('data-size-chart-unit-toggle') === unit));
  });

  modalBody.querySelectorAll('[data-size-chart-measurement]').forEach((cell) => {
    if (unit === 'cm') {
      if (!cell.dataset.cm) {
        cell.dataset.cm = inchesToCm(cell.dataset.in);
      }
      cell.textContent = cell.dataset.cm;
    } else {
      cell.textContent = cell.dataset.in;
    }
  });
});
